export const InboxesTreesViewName = 'inboxesTreesViewNameComponent';
